.navigation-link {
  > svg {
    margin-left: 5px;
  }
  &__wrapper {
    display: inline-flex;
    align-items: center;
    a {
      margin-right: 8px;
      display: inline-block;
      line-height: 1;
    }
  }
}
